import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach JWT from localStorage to every request as a Bearer header.
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("sendme_jwt") : null;
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export function saveToken(t) {
  if (t) localStorage.setItem("sendme_jwt", t);
}
export function clearToken() {
  localStorage.removeItem("sendme_jwt");
}
export function getToken() {
  return localStorage.getItem("sendme_jwt");
}

// Format any FastAPI/axios error to a string safe for rendering in React.
export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export default api;
